import { Product } from '../services/productService';

export function isDigitalProduct(
  product: Pick<Product, 'specifications' | 'shipping'>
): boolean {
  return product.specifications?.productType === 'digital';
}

/** Flat shipping for one cart line — from vendor product settings. */
export function getProductLineShippingCost(product: Pick<Product, 'specifications' | 'shipping'>): number {
  if (isDigitalProduct(product)) {
    return 0;
  }
  if (product.shipping?.freeShipping) {
    return 0;
  }
  return Number(product.shipping?.shippingCost) || 0;
}

export function sumLineShippingCosts(items: { shippingCost: number }[]): number {
  return items.reduce((sum, item) => sum + (Number(item.shippingCost) || 0), 0);
}
